import { useMutation } from "@apollo/client";
import type {
  JoinOrganizationAsSuperadminPayload,
  JoinOrganizationAsSuperadminInput,
} from "@casey/db-types";
import { JOIN_ORGANIZATION_AS_SUPERADMIN_MUTATION } from "../gql/index";

export function useJoinOrganizationAsSuperadmin() {
  return useMutation<
    { joinOrganizationAsSuperadmin: JoinOrganizationAsSuperadminPayload },
    JoinOrganizationAsSuperadminInput
  >(JOIN_ORGANIZATION_AS_SUPERADMIN_MUTATION);
}
